import React, { useRef } from 'react'
import ClickableImageCard from '../custom-components/ClickableImageCard';
import './TWSS.css';

function TheWestsideStore() {

    const carouselRef = useRef(null);
    
    const scroll = (direction) => {
        const scrollAmount = 300;
        carouselRef.current.scrollBy({
        left: direction === 'left' ? -scrollAmount : scrollAmount,
        behavior: 'smooth'
        });
    };


    const deals = [
        {id: 1, bboo: "one", image: "https://assets.tatacliq.com/medias/sys_master/images/64002753560606.png"},
        {id: 2, bboo: "two", image: "https://assets.tatacliq.com/medias/sys_master/images/64002753626142.png"},
        {id: 3, bboo: "three", image: "https://assets.tatacliq.com/medias/sys_master/images/64002753691678.png"},
        {id: 4, bboo: "four", image: "https://assets.tatacliq.com/medias/sys_master/images/64002753757214.png"},
        {id: 5, bboo: "five", image: "https://assets.tatacliq.com/medias/sys_master/images/64002753822750.png"},
        {id: 6, bboo: "six", image: "https://assets.tatacliq.com/medias/sys_master/images/64002753888286.png"},
        {id: 7, bboo: "seven", image: "https://assets.tatacliq.com/medias/sys_master/images/64002753953822.png"},
        {id: 8, bboo: "eight", image: "https://assets.tatacliq.com/medias/sys_master/images/64002754019358.png"},
        {id: 9, bboo: "nine", image: "https://assets.tatacliq.com/medias/sys_master/images/64002754084894.png"},
        {id: 10, bboo: "ten", image: "https://assets.tatacliq.com/medias/sys_master/images/64002754215966.png"},
    ];




    return (
        <div className="carousel-container">
          <div className="carousel-controls justify-content-end mb-5">
              <button onClick={() => scroll('left')} className="control-button">
                &lt;
              </button>
              <button onClick={() => scroll('right')} className="control-button">
                &gt;
              </button>
            </div>
          
          <div className="image-carousel" ref={carouselRef}>
            {deals.map((deal) => (
              <ClickableImageCard key={deal.id} item={deal} />
            ))}
          </div>
        </div>
      );
}

export default TheWestsideStore